import { render } from "./PagerInformation.vue?vue&type=template&id=5b711d0a"
import script from "./PagerInformation.vue?vue&type=script&lang=js"
export * from "./PagerInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__